import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccb53b64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mr-3 p-ml-3 p-my-2 p-text-right f-size-14 textc-primary" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"120px"} }, null, -1))
const _hoisted_3 = { class: "p-p-3 shadow fixed-bottom bg-white" }
const _hoisted_4 = { class: "p-d-flex p-jc-between p-pb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ", -1))
const _hoisted_6 = ["action"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentChanelForm = _resolveComponent("PaymentChanelForm")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("u", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onHandleChangeBuyerInfo())),
        class: "pointer"
      }, "เปลี่ยนแปลงข้อมูลผู้ซื้อ")
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_PaymentChanelForm, { onOnHandleSelectePayment: _ctx.onHandleSelectePayment }, null, 8, ["onOnHandleSelectePayment"])
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)), 1)
      ]),
      _createVNode(_component_Button, {
        class: "bg-black w-100",
        label: "ชำระเงิน",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit()))
      })
    ]),
    (_ctx.paymentForm)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          id: "myform",
          method: "post",
          action: _ctx.paymentForm.paymentUrl
        }, [
          _createElementVNode("input", {
            type: "hidden",
            name: "paymentRequest",
            value: _ctx.paymentForm.xml,
            readonly: ""
          }, null, 8, _hoisted_7),
          _createElementVNode("input", {
            type: "hidden",
            name: "version",
            value: _ctx.paymentForm.version
          }, null, 8, _hoisted_8),
          _createElementVNode("input", {
            type: "hidden",
            name: "merchant_id",
            value: _ctx.paymentForm.merchantId
          }, null, 8, _hoisted_9),
          _createElementVNode("input", {
            type: "hidden",
            name: "currency",
            value: _ctx.paymentForm.currencyCode
          }, null, 8, _hoisted_10),
          _createElementVNode("input", {
            type: "hidden",
            name: "result_url_1",
            value: _ctx.paymentForm.resultUrl
          }, null, 8, _hoisted_11),
          _createElementVNode("input", {
            type: "hidden",
            name: "hash_value",
            value: _ctx.paymentForm.hashValue
          }, null, 8, _hoisted_12),
          _createElementVNode("input", {
            type: "hidden",
            name: "payment_description",
            value: _ctx.paymentForm.paymentDescription,
            readonly: ""
          }, null, 8, _hoisted_13),
          _createElementVNode("input", {
            type: "hidden",
            name: "order_id",
            value: _ctx.paymentForm.uniqueTransactionCode,
            readonly: ""
          }, null, 8, _hoisted_14),
          _createElementVNode("input", {
            type: "hidden",
            name: "amount",
            value: _ctx.paymentForm.amount,
            readonly: ""
          }, null, 8, _hoisted_15),
          _createElementVNode("input", {
            type: "hidden",
            name: "payment_option",
            value: _ctx.paymentForm.paymentOption,
            readonly: ""
          }, null, 8, _hoisted_16)
        ], 8, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}